var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 9C13.6046 9 14.5 8.10457 14.5 7C14.5 5.89543 13.6046 5 12.5 5C11.3954 5 10.5 5.89543 10.5 7C10.5 8.10457 11.3954 9 12.5 9ZM12.59 18.81C12.95 18.68 13.43 18.5 14.04 18.26L14.25 17.44C14.14 17.49 13.97 17.55 13.74 17.61C13.5 17.68 13.3 17.71 13.11 17.71C12.72 17.71 12.44 17.65 12.28 17.52C12.12 17.39 12.04 17.15 12.04 16.79C12.04 16.65 12.06 16.43 12.11 16.16C12.16 15.88 12.22 15.64 12.28 15.42L13.01 13.34C13.08 13.09 13.13 12.83 13.16 12.53C13.19 12.23 13.2 12.03 13.2 11.91C13.2 11.34 13.01 10.88 12.61 10.53C12.22 10.18 11.65 10 10.92 10C10.52 10 10.08 10.07 9.63 10.22C9.18 10.36 8.7 10.54 8.2 10.74L8 11.57C8.15 11.51 8.33 11.45 8.53 11.39C8.74 11.33 8.94 11.3 9.14 11.3C9.54 11.3 9.81 11.36 9.95 11.5C10.09 11.64 10.16 11.88 10.16 12.22C10.16 12.41 10.14 12.62 10.09 12.85C10.0839 12.8779 10.0779 12.9059 10.0718 12.9341C10.0276 13.1385 9.98151 13.3515 9.92 13.58L9.19 15.67C9.12 15.95 9.07 16.2 9.05 16.43C9.02 16.66 9 16.87 9 17.09C9 17.65 9.2 18.1 9.61 18.46C10.02 18.82 10.59 19 11.33 19C11.81 19 12.23 18.94 12.59 18.81Z",
    fill: "#4D313D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.b7709976e932663f15e55fe787b34c56.svg";
export { ForwardRef as ReactComponent };